import { render, staticRenderFns } from "./SectionBuilder.vue?vue&type=template&id=2b0570b4&"
import script from "./SectionBuilder.vue?vue&type=script&lang=js&"
export * from "./SectionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./SectionBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports